import React from 'react';
import { FiZap } from 'react-icons/fi';
import ModalBase from '../../Modal/ModalBase';

// Trial gate shown when an unsubscribed user tries to ask a question. Opened through ModalGlobal (modalViewsConst.noSubscription, __modalSize: "sm").

interface NoSubscriptionModalProps {
  /** Provided by ModalGlobal — closes the modal. */
  onClose: (result?: any) => void;
}

const NoSubscriptionModal: React.FC<NoSubscriptionModalProps> = ({ onClose }) => {
  const handleStartTrial = () => {
    window.location.href = '/home/subscriptions';
  };

  return (
    <ModalBase
      title="Start Your Free Trial"
      icon={<FiZap className="h-5 w-5 text-eai-cta-primary" />}
      onClose={onClose}
      size="sm"
      footer={
        <>
          {/* sm stretches its footer buttons, so the secondary action leads */}
          <button type="button" onClick={() => onClose()} className="eai-btn-outline">
            Maybe Later
          </button>
          <button type="button" onClick={handleStartTrial} className="eai-btn-cta">
            Start Free Trial
          </button>
        </>
      }
    >
      <p className="eai-description-sm">
        Sign up for your free trial to start asking questions and unlock the full power of AI Analyst.
      </p>
    </ModalBase>
  );
};

export default NoSubscriptionModal;
